import {
	MONTHS,
	WEEK_DAYS,
	POSITION_DEFAULT,
	POSITION_LAST,
	CURRENT_DATE,
	TOTAL,
	LATEST,
	CURRENT_YEAR,
} from "../constants";
import formatTwoDigits from "./formatTwoDigits";

const createPeriods = ({ selected, fromYear, fromMonth, t }) => {
	const result = [
		{
			key: LATEST,
			value: LATEST,
			content: t("filtersAndSelectors:period.latest"),
			isDisplayed: (date = selected.date) => date.year === CURRENT_YEAR,
			asDate: () => ({
				year: CURRENT_YEAR,
				month: null,
				day: null,
			}),
		},

		{
			key: TOTAL,
			value: TOTAL,
			content: t("filtersAndSelectors:period.total"),
			position: (date = selected.date) =>
				CURRENT_YEAR === date.year ? POSITION_LAST : POSITION_DEFAULT,
			isDisplayed: () => true,
			asDate: (date) => ({
				year: date.year,
				month: null,
				day: null,
			}),
		},

		...WEEK_DAYS.map((day, index) => {
			const today = new Date();
			today.setDate(today.getDate() - index); // Zmniejszenie daty o wartość indeksu

			// Funkcja pomocnicza do dodawania zera przed liczbami < 10
			function addLeadingZero(number) {
				return number < 10 ? `0${number}` : number;
			}
			// Formatowanie daty w formacie "dd-MM-yyyy"
			const formattedDate1 = `${addLeadingZero(
				today.getDate()
			)}-${addLeadingZero(today.getMonth() + 1)}-${today.getFullYear()}`;
			// Formatowanie daty w formacie "dd.MM.yyyy"
			const formattedDate2 = `${addLeadingZero(
				today.getDate()
			)}.${addLeadingZero(today.getMonth() + 1)}.${today.getFullYear()}`;

			return {
				key: `week-${day}`,
				value: formattedDate1,
				content: formattedDate2,
				isDisplayed: (date = selected.date) =>
					date.year === today.getFullYear(),
				asDate: () => ({
					year: today.getFullYear(),
					month: today.getMonth(),
					day: today.getDay(),
				}),
			};
		}),

		...MONTHS.map((month, index) => {
			const dateSelected = selected.date;
			const showMonth =
				dateSelected.year === parseInt(fromYear)
					? parseInt(fromMonth) - 1
					: 0;

			if (index >= showMonth) {
				return {
					key: month.text,
					value: month.text,
					number: month.number,
					content: t(`common:months.${month.text}`),
					isDisplayed: (date = selected.date) => {
						const listedMonths =
							date.year === CURRENT_YEAR
								? CURRENT_DATE.getMonth()
								: 11;

						return index <= listedMonths;
					},
					asDate: (date) => ({
						year: date.year,
						month: index,
						day: null,
					}),
				};
			} else {
				return {
					key: month.text,
					value: month.text,
					number: month.number,
					content: t(`common:months.${month.text}`),
					isDisplayed: () => {
						return false;
					},
					asDate: (date) => ({
						year: date.year,
						month: index,
						day: null,
					}),
				};
			}
		}).reverse(),
	];

	return Object.assign(result, {
		asFiltered() {
			const filtered = this.filter((period) => {
				if (typeof period.isDisplayed === "function") {
					return period.isDisplayed();
				}

				return true;
			});

			for (const index in filtered) {
				const period = filtered[index];

				if (
					period.position == null ||
					typeof period.position !== "function"
				) {
					continue;
				}

				switch (period.position()) {
					case POSITION_DEFAULT:
						continue;
					case POSITION_LAST: {
						filtered.splice(index, 1);
						filtered.push(period);
						continue;
					}
				}
			}

			return filtered;
		},

		firstDisplayed(date = selected.date) {
			return this.find((period) => period.isDisplayed(date));
		},

		asDate(value, state) {
			const period = this.find((period) => period.value === value);

			if (period == null) {
				throw new Error(`Period found null by value: ${value}`);
			}

			if (!period.isDisplayed()) {
				return this.firstDisplayed().asDate(state);
			}

			return period.asDate(state);
		},

		findByDate(query) {
			if (query.month == null) {
				return this.find((period) => period.value === TOTAL);
			}

			if (query.day == null) {
				return this.find(
					(period) => period.value === MONTHS[query.month].text
				);
			}

			const date = [
				formatTwoDigits(query.day),
				formatTwoDigits(query.month, 1),
				query.year,
			]
				.filter((value) => value != null)
				.join("-");

			return this.find((period) => period.value === date);
		},

		normalizeByDate(date) {
			const period = this.findByDate(date);
			if (period == null) {
				return {
					date: {
						day: null,
						month: null,
						year: CURRENT_YEAR,
					},
					year: CURRENT_YEAR,
					period: LATEST,
				};
			}
			if (period.value === TOTAL) {
				return {
					date,
					year: date.year,
					period: TOTAL,
				};
			}
			if (period.value === LATEST) {
				return {
					date,
					year: CURRENT_YEAR,
					period: LATEST,
				};
			}
			if (!period.isDisplayed()) {
				const first = this.firstDisplayed(date);
				return {
					date: first.asDate(date),
					year: date.year,
					period: first.value,
				};
			}
			return {
				date,
				year: date.year,
				period: period.value,
			};
		},
	});
};

export default createPeriods;
